export default "__VITE_ASSET__D1vzEpi8__"